var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66675C8.89337 8.73342 5.33337 13.9734 5.33337 18.4001C5.33337 25.0401 10.4 29.3334 16 29.3334C21.6 29.3334 26.6667 25.0401 26.6667 18.4001C26.6667 13.9734 23.1067 8.73342 16 2.66675ZM16 26.6667C11.5334 26.6667 8.00004 23.2401 8.00004 18.4001C8.00004 15.2801 10.6 11.1467 16 6.21341C21.4 11.1467 24 15.2667 24 18.4001C24 23.2401 20.4667 26.6667 16 26.6667ZM10.44 18.6667C10.9334 18.6667 11.3334 19.0134 11.4267 19.4934C11.9734 22.4534 14.4667 23.4667 16.28 23.3201C16.8534 23.2934 17.3334 23.7467 17.3334 24.3201C17.3334 24.8534 16.9067 25.2934 16.3734 25.3201C13.5334 25.4934 10.2134 23.8667 9.45337 19.8267C9.4302 19.6838 9.43836 19.5375 9.47727 19.398C9.51619 19.2585 9.58494 19.1292 9.67877 19.0188C9.7726 18.9085 9.88926 18.8199 10.0207 18.7591C10.1521 18.6983 10.2952 18.6668 10.44 18.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.37c469c2c0f86e555d67a1a1ae99f382.svg";
export { ForwardRef as ReactComponent };